module.exports = __webpack_public_path__ + "static/img_life_saving_gift_banner_4@2x-ee60f7d821f562cd25baade6e9b68d3d.jpg";